import {
  Grid,
  TextField,
  Typography,
  makeStyles,
  InputAdornment,
} from "@material-ui/core";
import React from "react";
import Styles from "../../../Styles.module.css";
import SearchIcon from "@material-ui/icons/Search";
import AppItem from "./AppItem";

const useStyles = makeStyles((theme) => ({
  textField: { padding: "15px 14px !important" },
}));

const lawyerApps = [
  {
    imageUrl: "/app/images/apps/realtor/docu_sign.png",
    title: "Docusign",
    description:
      "DocuSign is the most reliable and globally trusted service for electronic signatures and…",
  },
  {
    imageUrl: "/app/images/apps/lawyers/adobeSign.png",
    title: "AdobeSign",
    description:
      "Adobe Sign is a cloud-based e-signature service that allows the user to send, sign, track, a…",
  },
  {
    imageUrl: "/app/images/apps/deposit_rocket.png",
    title: "DepositRocket",
    description:
      "It is simply a guarantee that you will pay the required deposit upon closing of the…",
  },
  {
    imageUrl: "/app/images/apps/realtor/google_drive.png",
    title: "Google Drive",
    description:
      "Drive integrates seamlessly with Docs, Sheets, and Slides, cloud-native apps that enabl…",
  },
  {
    imageUrl: "/app/images/apps/realtor/onedrive.png",
    title: "OneDrive",
    description:
      "Share files and store photos online, and access on any device with OneDrive cloud st…",
  },
  {
    imageUrl: "/app/images/apps/realtor/dropbox.png",
    title: "DropBox",
    description:
      "Bring your files and cloud content together with the tools your team wants to use.",
  },
  {
    imageUrl: "/app/images/apps/lawyers/zapier.png",
    title: "Zapier",
    description: "Zapier helps you get stuff done. Save time with automations.",
  },
  {
    imageUrl: "/app/images/apps/lawyers/realtiWeb.png",
    title: "RealtiWeb",
    description:
      "RealtiWeb puts you in control of real estate transactions. You can produce documents, hos…",
  },
  {
    imageUrl: "/app/images/apps/notarize.png",
    title: "Notarize",
    description: "Legally sign and notarize documents 100% online.",
  },
];
export default function Lawyers() {
  const classes = useStyles();

  return (
    <Grid
      container
      style={{
        padding: "0 24px 120px 24px",
      }}
    >
      <Typography variant="h4" className={Styles.navyBlueColor}>
        Lawyer Apps ({lawyerApps && lawyerApps.length})
      </Typography>
      <Grid item xs={12}>
        <TextField
          disabled
          variant="outlined"
          fullWidth
          placeholder="Search your client here by name, email address or phone number"
          style={{
            backgroundColor: "#FFFFFF",
            marginTop: 20,
          }}
          InputProps={{
            classes: { input: classes.textField },
            endAdornment: (
              <InputAdornment position="end">
                <SearchIcon />
              </InputAdornment>
            ),
          }}
        />
      </Grid>
      <Grid item xs={12}>
        <img
          style={{ width: "100%", marginTop: 20, marginBottom: 20 }}
          src="/app/images/apps/apps_background.svg"
          alt="apps background"
          title="apps background"
        />
      </Grid>
      <Grid container spacing={3}>
        {lawyerApps &&
          lawyerApps.length &&
          lawyerApps.map((item) => <AppItem data={item} />)}
      </Grid>
    </Grid>
  );
}
